<script lang="ts">
  import { images } from './RoadmapImages.ts'

  export let title: string
  export let description: string
  export let date: string
  export let icon: string | undefined = undefined
  export let containerStyles: string = ''
  export let iconStyles: string
  export let descriptionStyles: string = ''
  export let completed: boolean = false
</script>

<li
  class="relative grid h-[220px] w-[calc(100vw-2rem)] max-w-[343px] grid-cols-2 {containerStyles} min-[360px]:h-[172px] md:h-[204px] md:w-[412px] md:max-w-none"
>
  <div
    class="{containerStyles} {completed
      ? 'gradient-border'
      : 'gradient-border-incomplete'} relative grid h-full w-full grid-cols-2 overflow-hidden rounded-[20px] bg-black p-4 md:py-6"
  >
    <h5
      class="col-span-2 font-cirka text-[22px] font-medium leading-tight tracking-wide min-[360px]:text-[24px] md:text-[36px] {completed &&
        'gradient-text'}"
    >
      {title}
    </h5>
    <p
      class="col-span-2 row-start-2 font-graphik text-base font-normal leading-[1.3] min-[360px]:text-[18px] min-[360px]:leading-[23.4px] md:text-[20px] {descriptionStyles}"
    >
      {description}
    </p>

    <p class="row-start-3 mt-4 uppercase text-silver">{date}</p>

    {#if icon}
      <img
        src={icon}
        alt="roadmap icon"
        class="absolute col-span-2 col-start-2 row-start-3 justify-self-end {iconStyles}"
        width="100"
        height="100"
      />
    {/if}
  </div>
  <img
    src={images.checkSvg}
    width="25"
    height="25"
    alt="check"
    class="absolute left-3 top-[-5px] z-[1] {completed ? 'block' : 'hidden'}"
  />
</li>

<style lang="postcss">
  .gradient-border {
    --gradient-border: linear-gradient(to bottom right, #24caff 20%, #fdb1a8 40%, #ffa564 50%, #050505 70%);
    position: relative;
    border-radius: 20px;
    background: black;
  }

  .gradient-border-incomplete {
    --gradient-border: linear-gradient(to bottom, #323948 0%, #323948 35%, #050505 75%, #050505 100%);
    position: relative;
    border-radius: 20px;
    background: black;
  }

  .gradient-text {
    background-image: linear-gradient(to bottom right, #24caff 5%, #fdb1a8 60%, #ffa564 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .gradient-border::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 20px;
    padding: 1px;
    background: var(--gradient-border);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  .gradient-border-incomplete::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 20px;
    padding: 1px;
    background: var(--gradient-border);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
</style>
